"use client"
import TripCard from '@/components/global/trip-card'
import { Skeleton } from '@/components/ui/skeleton'
import { api } from '@/trpc/react'
import React from 'react'

export default function DestinationTrips({ id }: { id: string }) {
    const { data, isLoading } = api.trips.get_trip_by_destination_id.useQuery({ id })

    if (isLoading) return <div>
        <div className='grid sm:grid-cols-2 lg:grid-cols-3 min-[1500px]:grid-cols-4 gap-8 lg:gap-x-5 min-[350px]:px-2 min-[400px]:px-6 min-[800px]:px-0'>
            {Array.from({ length: 8 }).map((data, i) => (
                <Skeleton key={i} className='rounded-lg overflow-hidden h-96 w-full max-w-96 mx-auto bg-gray-300' />
            ))}
        </div>
    </div>

    return (
        <div className='grid sm:grid-cols-2 lg:grid-cols-3 min-[1500px]:grid-cols-4 gap-8 lg:gap-x-5 min-[350px]:px-2 min-[400px]:px-6 min-[800px]:px-0'>
            {data?.map((data) => (
                <TripCard
                    key={data.slug}
                    data={data}
                    isTrips={data.adentureType === 'Trip' ? true : false}
                />
            ))}
        </div>
    )
}
